export default __webpack_public_path__ + "static/summer_containers89-e0854a6d9f5f529f608c15295ef87620.webp";